import { useI18n } from "../i18n/I18nProvider";

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  return (
    <div className="flex border border-[var(--ink-200)]" data-testid="language-switcher">
      <button
        onClick={() => setLang("sv")}
        className={`px-2 py-1 text-[11px] font-mono-tech uppercase tracking-[0.1em] ${lang === "sv" ? "bg-[var(--ink)] text-[var(--bone)]" : "bg-[var(--surface)] text-[var(--ink-500)] hover:text-[var(--ink)]"}`}
        data-testid="lang-sv-btn"
      >
        SV
      </button>
      <button
        onClick={() => setLang("en")}
        className={`px-2 py-1 text-[11px] font-mono-tech uppercase tracking-[0.1em] border-l border-[var(--ink-200)] ${lang === "en" ? "bg-[var(--ink)] text-[var(--bone)]" : "bg-[var(--surface)] text-[var(--ink-500)] hover:text-[var(--ink)]"}`}
        data-testid="lang-en-btn"
      >
        EN
      </button>
    </div>
  );
}
